import Link from 'next/link'

import s from './ApplyStepButtons.module.css'

//TODO: setup proptypes
function ApplyStepButtons({ back, next }) {
  const nextButton = next ? (
    <button type="button" className={s.button} onClick={next}>
      Next
    </button>
  ) : (
    <input type="submit" className={s.button} value="Next" />
  )
  if (!back) return nextButton

  return (
    <div className={s.container}>
      {typeof back === 'string' ? (
        <Link href={back} className={s.button}>
          Back
        </Link>
      ) : (
        <button type="button" className={s.button} onClick={back}>
          Back
        </button>
      )}
      {nextButton}
    </div>
  );
}

export default ApplyStepButtons
